<template lang="pug">
span {{ currentTime }}
</template>
<script>
import format from 'date-fns/format/index.js';

export default {
  data() {
    return {
      timezoneDialog: false,
      currentTime: '',
      intervalId: null,
    };
  },
  mounted() {
    this.intervalId = setInterval(this.setCurrentTime, 1000);
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
  methods:{
    setCurrentTime() {
      this.currentTime = format(new Date(), 'HH:mm:ss');
    },
  },
};
</script>

<style>

</style>
